import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { normalize, schema } from 'normalizr';

import {
  GET_ASSETS,
  RESET_ASSETS_LIST,
  SET_ASSETS_FILTERS,
  SET_ASSETS_PAGINATION,
  GET_ASSETS_CSV,
} from 'containers/assets/constants';

const asset = new schema.Entity('assets');

export const initialState = {
  filters: {
    fulltext: '',
    exactSearch: false,
    accounts: '',
    employees: '',
    costCenters: '',
    status: '',
    areDisabled: 'no',
    hasPendingChanges: 'both',
    location: '',
    columnSearch: [
      'indexInteger.numberString',
      '_prefix.value',
      'number',
      'name',
      'serie',
      'description',
      '_account.name',
      '_subaccount.name',
      '_costCenter.name',
      '_employee.name',
      '_provider.name',
      'buyOrder',
      'billNumber',
      'billFolio',
      'billConcept',
    ],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  selectedAsset: null,
  needFetch: false,
  isLoading: false,
  entities: { assets: {} },
  result: { assets: [] },
};

export const getPending = (state) => ({
  ...state,
  needFetch: false,
  isLoading: true,
});
export const getRejected = (state) => ({
  ...state,
  isLoading: false,
});

export const getFulfilled = (state, { payload }) => {
  //TODO: implementar limit a la paginacion.
  const pagination = {
    ...state.pagination,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ assets: payload.records }, { assets: [asset] });

  return {
    ...state,
    isLoading: false,
    pagination,
    ...normalized,
  };
};

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const getCSVPending = (state) => ({ ...state, isLoading: true });
export const getCSVRejected = (state) => ({ ...state, isLoading: false });
export const getCSVFulfilled = (state) => ({ ...state, isLoading: false });

export const reset = (state) => ({ ...initialState });

const listReducers = {
  [GET_ASSETS_CSV]: {
    [PENDING]: getCSVPending,
    [REJECTED]: getCSVRejected,
    [FULFILLED]: getCSVFulfilled,
  },
  [GET_ASSETS]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [SET_ASSETS_PAGINATION]: setPagination,
  [SET_ASSETS_FILTERS]: setFilters,
  [RESET_ASSETS_LIST]: reset,
};

export default TypeToReducer(listReducers, initialState);



// WEBPACK FOOTER //
// src/containers/assets/reducers_list.js